module.exports = __webpack_public_path__ + "img/logoksai-old.626a1098.png";